import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function sanitizeInput(input) {
  if (typeof input !== 'string') return input;
  return input.replace(/[&<>'"]/g, function (char) {
    const entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    };
    return entityMap[char];
  });
}
